import r from "./index.es498.js";
import o from "./index.es499.js";
function f(t) {
  return r(o(t), {
    attribute: !1
  });
}
export {
  f as default
};
//# sourceMappingURL=index.es474.js.map
